import React from "react";
import { Box } from "@mui/material";
import useTheme from "../../../common/hooks/useTheme";
import { Theme } from "../../../providers/ThemeProvider";
import MeasurementUnitSettings from "../components/settings/MeasurementUnitSettings";
import InBodyIntegrationSettings from "../components/settings/InBodyIntegrationSettings";
import KeragonSyncSettings from "../components/settings/KeragonSyncSettings";

const SettingsScreen = () => {
  const theme: Theme = useTheme();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header(theme)}>Settings</Box>

      <Box sx={styles.content}>
        <MeasurementUnitSettings />
        <InBodyIntegrationSettings />
        <KeragonSyncSettings />
      </Box>
    </Box>
  );
};

export default SettingsScreen;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as "column",
    height: "100%",
    gap: "24px",
  },
  header: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "20px",
    lineHeight: "28px",
    color: theme.colorTokens.N[90], // #3B3F42
  }),
  content: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "24px",
    flex: 1,
    // Breathing room under the last card (the Keragon list grows with rows and
    // its inline form), so the page never ends flush against the viewport.
    paddingBottom: "60px",
  },
};
